import api, { fetchAllPages } from "./client";

export const cajasApi = {
  getConfiguration: () => api.get("/cajas/configuracion/"),
  updateConfiguration: (data) => api.patch("/cajas/configuracion/", data),
  getCurrent: () => api.get("/cajas/actual/"),
  getAll: () => fetchAllPages("/cajas/"),
  open: (data) => api.post("/cajas/abrir/", data),
  reopen: (id) => api.post(`/cajas/${id}/reabrir/`),
  close: (id, data) => api.post(`/cajas/${id}/cerrar/`, data),
};
